import { render, staticRenderFns } from "./Sessions.vue?vue&type=template&id=2678e810"
import script from "./Sessions.vue?vue&type=script&lang=js"
export * from "./Sessions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports